export const canvasToPng = async (canvas: HTMLCanvasElement) => {
  const base64 = canvas.toDataURL("image/png");
  const blob = await fetch(base64).then((res) => res.blob());

  return new File([blob], "tinted", {
    type: "image/png",
  });
};
